// extracted by mini-css-extract-plugin
module.exports = {"nfts":"V7LHzp","nft":"X_dEPd","nftData":"_qOwAU","iconContainer":"yrgMmM","clickable":"Kt_xi7"};